import { useEffect, useState } from "react";

/** How long a transient notice popup stays before it auto-dismisses. */
export const NOTICE_DISMISS_MS = 5000;

/**
 * Auto-dismiss a transient notice popup after {@link NOTICE_DISMISS_MS}.
 *
 * Returns whether the notice identified by `activeKey` has elapsed its window.
 * Pass `undefined` when no notice is showing (stays undismissed); a changed key
 * restarts the countdown so a fresh notice always gets its full 5 seconds.
 */
export function useNoticeAutoDismiss(activeKey: string | undefined): boolean {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    setDismissed(false);
    if (activeKey === undefined) return;
    const timer = window.setTimeout(
      () => setDismissed(true),
      NOTICE_DISMISS_MS,
    );
    return () => window.clearTimeout(timer);
  }, [activeKey]);
  return dismissed;
}
